import type { FractionIsh, NumberIsh } from 'bi-fraction';
import { Fraction } from 'bi-fraction';
import type { useTranslations } from 'next-intl';

export const validateNotEmpty = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (!value.trim()) {
    return t('common.required');
  }
};

export const validateNotZero = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (new Fraction(value).eq(0)) {
    return t('common.cannot be zero');
  }
};

export const validateNumberFormat = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (!/^\d+$/.test(value) && !/^\d+\.\d+$/.test(value)) {
    return t('common.invalid value');
  }
};

export const validateMaxValue = ({
  t,
  value,
  maxValue,
  errorMessage,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  maxValue?: FractionIsh;
  errorMessage?: string;
}) => {
  if (maxValue && new Fraction(value).gt(maxValue)) {
    return errorMessage ?? t('common.insufficient balance');
  }
};

export const validateMinValue = ({
  t,
  value,
  minValue,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  minValue?: NumberIsh;
}) => {
  if (minValue && new Fraction(value).lt(minValue)) {
    return t('common.must be at least {min}', {
      min: String(minValue),
    });
  }
};

export const validateMaxDecimals = ({
  t,
  value,
  maxDecimals,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  maxDecimals: number;
}) => {
  const decimalPart = value.split('.')[1];
  if (decimalPart && decimalPart.length > maxDecimals) {
    return t('common.maximum number of decimals is {decimals}', {
      decimals: maxDecimals,
    });
  }
};
